module.exports = __webpack_public_path__ + "04cb77716fb87253d5ba0e4007f2c324.pdf";